/*
saikrishna 10/04/2022 2698821717 Client and role bugs fixed
saikrishna 10/06/2022 2698821717 Fixed jira bugs in client maintenance.jira(417,18,384,263)
Suresh Peddavoora 10/30/2022 2698821717 - Added classname for table enhancements.
saikrishna 11/03/2022 2698821717 changed the paginationOptions
akhila 11/03/2022 2698821717 TablePagination bugFix
*/

import React, {useEffect, useState} from 'react';
import {TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import moment from 'moment';
// import MaterialTable from "material-table";
import {useSelector} from 'react-redux';
import {SuccessSnackbar} from '../../../components/CustomSnackBar';
import MouseOverPopover from '../../../components/MousePopOver/MousePopOver';
import PageLoader from '../../../components/PageLoader';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../constants/ReusableConstants';
import {defaultRows} from '../../../constants/ReusableTablePagination';

const HistoryDialog = ({rowData}) => {
  const [history, setHistory] = useState([]);
  const [rows, setRows] = useState(defaultRows);
  const servicesColumns = [
    {
      title: 'Sub Service Type',
      field: 'subServiceType',
    },
    {
      title: 'Rate Type',
      field: 'feeType',
      lookup: {percentage: 'Percentage', flat: 'Flat Fee'},
      maxWidth: 90,
    },
    {
      title: 'Value',
      field: 'feeValue',
      type: 'numeric',
      maxWidth: 90,
      render: (rowData) =>
        rowData?.feeType?.toLowerCase() === 'flat' ?
          `$${(rowData?.feeValue).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}` :
          `${(rowData?.feeValue).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}%`,
    },
    {
      title: 'Effective Date',
      field: 'effectiveDate',
      maxWidth: 120,
      render: (rowData) => {
        return rowData.serviceStartDt ? <div >{moment(rowData.serviceStartDt).format('MM/DD/YYYY')}</div> : '_';
      },
    },
    {
      title: 'End Date',
      field: 'endDate',
      maxWidth: 100,
      render: (rowData) => {
        return rowData.serviceEndDt ? <div >{moment(rowData.serviceEndDt).format('MM/DD/YYYY')}</div> : '_';
      },
    },
    {
      title: 'Debtor Over Payments Remitted',
      field: 'paymentsRemitted',
      maxWidth: 250,
      render: (rowData) => {
        return rowData.paymentsRemitted ? <div >{rowData?.paymentsRemitted === 'send' ? 'Send' : 'Don\'t Send'}</div> : '_';
      },
    },
    {
      title: 'Inflation Agreement',
      field: 'inflationAgreement',
      maxWidth: 200,
      render: (rowData) => {
        return rowData.inflationAgreement ? <div >{rowData?.inflationAgreement}</div> : '_';
      },
    },
    {
      title: 'Postage Agreement',
      field: 'postageAgreement',
      maxWidth: 200,
      render: (rowData) => {
        return rowData.postageAgreement ? <div >{rowData?.postageAgreement}</div> : '_';
      },
    },
    {
      title: 'Notes',
      field: 'rateNotes',
      render: (rowData) => (
        <>
          {rowData.rateNotes ? <MouseOverPopover
            data={rowData.rateNotes}
            popOverData={rowData.rateNotes}
            codeLength={rowData?.rateNotes?.length}
          /> : '-'}
        </>
      ),
    },
  ];
  const {rateHistory, isHistoryLoading, successMsg} = useSelector(
    ({clientRateHistory}) => clientRateHistory,
  );
  let newData = [];
  useEffect(() => {
    newData =
      rateHistory && rateHistory.length > 0 ?
        rateHistory.map((item, i) => ({
          ...item,
          id: i,
        })) :
        [];
    setHistory(newData);
  }, [rateHistory]);

  return (
    <div className="col">
      <div className="custom-table global-field-table">
        <GuiTable
          columns={servicesColumns}
          icons={tableIcons}
          data={history.length > 0 ? history : []}
          components={{
            Pagination: (props) => (
              <TablePagination
                {...props}
                SelectProps={{
                  inputProps: {'aria-label': 'Rows per screen'},
                }}
                labelRowsPerPage={'Rows per screen:'}
                rowsPerPageOptions={tablePageRows}
                onChangeRowsPerPage={(event) => {
                  props.onChangeRowsPerPage(event);
                  setRows(event.target.value);
                }}
              />
            ),
          }}
          options={{
            search: false,
            toolbar: false,
            pageSize: rows,
            debounceInterval: 500,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          onSelectionChange={(rows) => rows}
        />
      </div>
      {isHistoryLoading && <PageLoader />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
};

export default HistoryDialog;
